function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M16.0002 5.33333C10.1068 5.33333 5.3335 10.1067 5.3335 16C5.3335 18.6 6.26683 20.9733 7.8135 22.8267C10.0668 21.0667 12.9068 20 16.0002 20C19.0935 20 21.9335 21.0667 24.1868 22.8267C25.7335 20.9733 26.6668 18.6 26.6668 16C26.6668 10.1067 21.8935 5.33333 16.0002 5.33333ZM16.0002 17.3333C13.4268 17.3333 11.3335 15.24 11.3335 12.6667C11.3335 10.0933 13.4268 8 16.0002 8C18.5735 8 20.6668 10.0933 20.6668 12.6667C20.6668 15.24 18.5735 17.3333 16.0002 17.3333Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.0001 2.66667C8.64008 2.66667 2.66675 8.64 2.66675 16C2.66675 23.36 8.64008 29.3333 16.0001 29.3333C23.3601 29.3333 29.3334 23.36 29.3334 16C29.3334 8.64 23.3601 2.66667 16.0001 2.66667ZM16.0001 26.6667C13.6801 26.6667 11.5467 25.92 9.80008 24.6667C11.5467 23.4133 13.6801 22.6667 16.0001 22.6667C18.3201 22.6667 20.4534 23.4133 22.2001 24.6667C20.4534 25.92 18.3201 26.6667 16.0001 26.6667ZM24.1867 22.8267C21.9334 21.0667 19.0934 20 16.0001 20C12.9067 20 10.0667 21.0667 7.81341 22.8267C6.26675 20.9733 5.33341 18.6 5.33341 16C5.33341 10.1067 10.1067 5.33333 16.0001 5.33333C21.8934 5.33333 26.6667 10.1067 26.6667 16C26.6667 18.6 25.7334 20.9733 24.1867 22.8267Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.0002 7.90667C13.4268 7.90667 11.3335 10 11.3335 12.5733C11.3335 15.1467 13.4268 17.24 16.0002 17.24C18.5735 17.24 20.6668 15.1467 20.6668 12.5733C20.6668 10 18.5735 7.90667 16.0002 7.90667ZM16.0002 14.5733C14.8935 14.5733 14.0002 13.68 14.0002 12.5733C14.0002 11.4667 14.8935 10.5733 16.0002 10.5733C17.1068 10.5733 18.0002 11.4667 18.0002 12.5733C18.0002 13.68 17.1068 14.5733 16.0002 14.5733Z",
  fill: "currentColor"
});

var SvgIcUserNew = function SvgIcUserNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcUserNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-user-new.70d86ecb.svg";
export { ForwardRef as ReactComponent };